export default {
    getCrumb(state) {
        var crumb = state.crumb[0]?state.crumb[0]:'';
        for(var i=1; i<state.crumb.length; i++) {
            crumb += ' > '+state.crumb[i];
        }
        return crumb;
    },
    getBattCountMax(state) {
        var batt = state.batt;
        var max = batt.analog_count;
        max = max<batt.state_count?batt.state_count:max;
        max = max<batt.switch_count?batt.switch_count:max;
        return max
    }
}